<template>
    <div class="d-flex flex-column justify-content-center px-0 px-lg-10 px-xl-15"
         :class="{'bg-white': complete, 'bg-light-success': !complete}"
         style="position: relative;">
        <!-- Content -->
        <slot v-if="!complete"/>
        <div v-else class="d-flex flex-row flex-lg-column text-center user-select-none p-4 p-lg-0">
            <div class="d-block d-lg-none mr-2">
                <i v-if="complete && !spinner" class="fas text-lg text-muted" :class="[icon]"/>
                <spinner v-if="spinner"
                         class="d-inline-block"
                         :size="16"
                         line-fg-color="indigo"
                         line-bg-color="transparent"
                />
            </div>
            <div v-if="title" :class="[titleClass]"
                 class="text-uppercase font-weight-bolder text-nowrap text-primary pr-2 pr-lg-0">
                {{ title }}
            </div>
            <div v-if="message" class="font-size-sm truncate text-nowrap pr-2 pr-lg-0">
                {{ message }}
            </div>
            <div v-if="timestamp" class="font-size-sm text-muted">
                {{ $localDate(timestamp, dateFormat) }}, {{ $localTime(timestamp) }}
            </div>
        </div>

        <!-- Icon -->
        <div v-if="complete || spinner" class="top-0 right-0 d-none d-lg-flex flex-column justify-content-center h-100"
             style="position: absolute; z-index: 10;">
            <div class="w-40px h-40px d-flex flex-column justify-content-center text-center text-white"
                 :class="[badgeClass || 'bg-primary']"
                 style="margin-right: calc((-0.5rem - 40px) / 2); border-radius: 100%; border: 0.45rem solid #eaf1f7;">
                <i v-if="complete && !spinner" class="fas text-lg" :class="[icon]"/>
                <spinner v-if="spinner" class="d-inline-block" :size="16" line-fg-color="#fff"
                         line-bg-color="transparent"/>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

export default {
    components: {
        Spinner,
    },

    props: {
        title: String,
        titleClass: String,
        badgeClass: String,
        message: String,
        timestamp: String,
        complete: Boolean,
        spinner: Boolean,
        icon: {
            type: String,
            default: 'fa-check-circle',
        },
    },

    data() {
        return {
            dateFormat: {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
            },
        }
    },
}
</script>
